import React from 'react';
import { connect } from 'react-redux'; 
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { buildSourceURL } from '../../utils/functions';
import { startAgainMobileQuestioner } from '../../actions/steps';
import { generateMenuContinue } from '../../actions/menus';
import styles from './DishesPage.module.css';

const DishList = (props) => {
  const { 
    menus, 
    isBalanced,
    startAgainMobileQuestioner,
    generateMenuContinue,
    onShowDish,
    onShowChangePage,
    onSuccess,
  } = props;

  // console.log('===MENUS', menus);

  const onChangeDishHandler = (dish, day) => {
    const selectedDish = {
      ...dish,
      day,
    };

    onShowDish(selectedDish);
  };

  const renderButtons = () => {
    if (isBalanced) {
      return (
        <div className={styles.bottomButtons}>
          <Link 
            className={styles.greenButton}
            to="/basket"
          >
            Basket
          </Link>
        </div>
      );
    }

    return (
      <div className={styles.bottomButtons}>
        <button 
          className={styles.transparentButton}
          onClick={startAgainMobileQuestioner}
        >
          Change preferences
        </button>
        <button 
          className={styles.greenButton} 
          onClick={() => generateMenuContinue(onSuccess)}
        >
          Approve menu
        </button>
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={cn(styles.dishesListContent, { [styles.balanced]: isBalanced })}>
        <div className={styles.title}>
          Review Plan
        </div>
        {menus.map((dishes, index) => {
          const day = index + 1;
          return (
            <div key={index} className={styles.menuItem}>
              <div className={styles.menuHeader}>
                Day {index + 1}/{menus.length}
              </div>
              {dishes.map((dish) => (
                <div 
                  key={dish.id} 
                  className={styles.dishItem}
                  onClick={() => onChangeDishHandler(dish, day)}
                >
                  <img
                    className={styles.dishImage}
                    src={buildSourceURL(dish.image)} 
                    alt={dish.name} 
                  />
                  <div>
                    <div className={styles.dishMealName}>
                      {dish.meal_name}
                    </div>
                    <div className={styles.dishName}>
                      {dish.name}
                    </div>
                    <div className={styles.dishCalories}>
                      {+dish.calories?.toFixed(1)} kcal
                    </div>
                    {!isBalanced && (
                      <div 
                        className={styles.changeMenuLink}
                        onClick={(event) => {
                          event.stopPropagation();
                          onShowChangePage({ day, meal: dish.meal_name });
                        }}
                      >
                        Change meal
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          );
        })}
        {renderButtons()}
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  startAgainMobileQuestioner,
  generateMenuContinue,
};

export default connect(null, mapDispatchToProps)(DishList);